// Constants for winner prize types
export const prizeTypeEnum = {
  GRAND: 'GRAND',
  MONTHLY: 'MONTHLY',
  WEEKLY: 'WEEKLY',
};

// Default number of winners to display initially
export const DEFAULT_WINNERS_DISPLAY_COUNT = 2;

// Default state structure for winners
export const getWinnersDefaultState = () => ({
  [prizeTypeEnum.GRAND]: [],
  [prizeTypeEnum.MONTHLY]: [],
  [prizeTypeEnum.WEEKLY]: [],
});

// Prize type display labels
export const prizeTypeLabels = {
  [prizeTypeEnum.GRAND]: 'Grand Prize Winners',
  [prizeTypeEnum.MONTHLY]: 'Monthly Winners',
  [prizeTypeEnum.WEEKLY]: 'Weekly Winners',
};

// Prize type order for display
export const prizeTypeOrder = [
  prizeTypeEnum.GRAND,
  prizeTypeEnum.MONTHLY,
  prizeTypeEnum.WEEKLY,
];
